import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';

export type ZCreditReportDeal = {
  transactionId: string | null;
  voucherNumber: string | null;
  terminalNumber: string | null;
  approvalNumber: string | null;
  rrn: string | null;
  cardLast4: string | null;
  cardBrand: string | null;
  statusText: string | null;
  status: 'approved' | 'reversed' | 'cancelled' | 'declined' | 'unknown';
  amount: number | null;
  occurredAt: string | null;
  dealTypeCode: string | null;
  panEntryMode: string | null;
};

export type ZCreditSessionTransactionsResponse = {
  session: { id: number; name: string; openTime: string; closingTime: string | null; state: 'open' | 'closed' };
  deals: ZCreditReportDeal[];
};

class ZCreditTransactionsService {
  private employeeSessionHeaders(employeeSession?: string): { headers?: Record<string, string> } {
    if (!employeeSession) {
      return {};
    }
    return { headers: { 'x-employee-session': employeeSession } };
  }

  async listForSession(
    tenantId: string,
    sessionId: number,
    employeeSession?: string,
  ): Promise<ZCreditSessionTransactionsResponse> {
    try {
      const response = await authenticatedInstance.get<ZCreditSessionTransactionsResponse>(
        `/payments/tenant/${encodeURIComponent(tenantId)}/credit/session/${sessionId}/transactions`,
        this.employeeSessionHeaders(employeeSession),
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }
}

export const zcreditTransactionsService = new ZCreditTransactionsService();
